import {useEffect, useRef} from 'react';

import {FilterOptionProps} from '../MyTeamsContent.types';

type UseLandingFiltersProps = {
  reportHeading?: string;
  ffTeamsOrgSR: boolean;
  updateTabFilters: (
    tab: 'my-teams' | 'watchlist',
    filters: {
      frontlineOnly?: boolean;
      newCoachesOptions?: FilterOptionProps[];
    },
  ) => void;
  currentFilters: {
    newCoachesOptions?: FilterOptionProps[];
  };
};

export const useLandingFilters = ({
  reportHeading,
  ffTeamsOrgSR,
  updateTabFilters,
  currentFilters,
}: UseLandingFiltersProps) => {
  const hasAppliedLandingFilter = useRef(false);

  useEffect(() => {
    if (
      !hasAppliedLandingFilter.current &&
      (reportHeading === 'New Frontline Coaches' ||
        reportHeading === 'New Organization Coaches')
    ) {
      const defaultId = ffTeamsOrgSR ? 'current' : '30';

      updateTabFilters('my-teams', {
        frontlineOnly: reportHeading === 'New Frontline Coaches',
        newCoachesOptions: currentFilters.newCoachesOptions?.map(option => ({
          ...option,
          selected: option.id === defaultId,
        })),
      });

      hasAppliedLandingFilter.current = true;
    }
  }, []);
};
